import { Turnstile } from '@marsidev/react-turnstile'
import axios from 'axios'
import { useState } from 'react'

interface Props {
  setIsValidated: (value: boolean) => void
  turnStileSiteKey: string
}

const TurnStileWidget = (props: Props): JSX.Element => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [retryKey, setRetryKey] = useState(0)

  const handleValidation = async (token: string | null): Promise<void> => {
    if (!token) {
      setErrorMessage('An error occurred during validation. Please try again.')
      setRetryKey((prevKey) => prevKey + 1)
      return
    }
    try {
      const response = await axios.post('/api/verify-turnstile', { token })
      const result = response.data
      if (result.success) {
        // Mark as validated
        props.setIsValidated(true)
        setErrorMessage(null)
      } else {
        console.error('Turnstile validation failed:', result.error)
        setErrorMessage('Human verification failed. Please try again.')
        setRetryKey((prevKey) => prevKey + 1)
      }
    } catch (error) {
      console.error('Error during Turnstile validation:', error)
      setErrorMessage('An error occurred during validation. Please try again.')
      setRetryKey((prevKey) => prevKey + 1)
    }
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1 className="text-xl font-bold mb-4">Human Validation Required</h1>
      {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      <Turnstile key={retryKey} siteKey={props.turnStileSiteKey} onSuccess={handleValidation} />
    </div>
  )
}

export default TurnStileWidget
